"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TDialogSizes = void 0;
var TDialogSizes;
(function (TDialogSizes) {
    TDialogSizes["Small"] = "sm";
    TDialogSizes["Medium"] = "md";
    TDialogSizes["Large"] = "lg";
    TDialogSizes["Full"] = "full";
    TDialogSizes["Liquid"] = "liquid";
    TDialogSizes["Bookings"] = "bookings";
})(TDialogSizes = exports.TDialogSizes || (exports.TDialogSizes = {}));
//# sourceMappingURL=dialogs.js.map